export * from "./util"
export { default as requestIdleCallback } from "./idle"
export const flatten = a => {
    if (typeof window !== "undefined") return a.flat()
    return a.reduce((acc, i) => acc.concat(Array.isArray(i) ? i : [i]), [])
}
